export default __webpack_public_path__ + "static/multiple-ways-illustration-dark-6d8df1675864486c1e9dbed122323164.svg";